import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  dialogPaper: {
    maxWidth: 844,
    width: "100%",
    height: 596,
    [theme.breakpoints.down("sm")]: {
      margin: 12,
      height: "85vh"
    }
  },
  dialogContent: {
    display: "flex",
    padding: 0,
    borderTop: `1px solid ${theme.palette.text.hint}`,
    [theme.breakpoints.down("sm")]: {
      padding: 0,
      borderTop: "none"
    }
  },
  dialogActions: {
    display: "flex",
    justifyContent: "right",
    padding: "20px 0 0 0"
  },
  dialogTitle: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    height: 58,
    "& h6": {
      width: "100%"
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: 20
    }
  },
  dialogTitleContent: {
    position: "relative",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      justifyContent: "space-between",
      paddingRight: 40,
      alignItems: "center"
    }
  },
  dialogTitleLabel: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontWeight: "bold",
    position: "absolute",
    left: 0,
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
      position: "relative"
    }
  },
  dialogTitleHorseName: {
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  detailsWrapper: {
    maxWidth: "100%",
    display: "flex",
    flex: "auto",
    "& > div": {
      maxWidth: "50%",
      flexGrow: 1
    }
  },
  detailsList: {
    display: "flex",
    flexDirection: "column",
    paddingTop: 18
  },
  detailsActivity: {
    overflowY: "auto"
  },
  actions: {
    display: "flex",
    alignItems: "end",
    justifyContent: "end",
    gap: 8,
    flexGrow: 1,
    padding: 22,
    [theme.breakpoints.down("sm")]: {
      position: "absolute",
      bottom: 0,
      right: 0
    }
  },
  tabsWrapper: {
    maxWidth: "100%",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      flex: "auto"
    }
  },
  tabs: {
    position: "sticky",
    top: 0,
    background: theme.palette.common.white,
    zIndex: 1
  },
  tabsContent: {
    [theme.breakpoints.down("sm")]: {
      flexGrow: 1,
      display: "flex"
    }
  },
  tabsViews: {
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      flex: "auto",
      "& .react-swipeable-view-container": {
        flexGrow: 1
      }
    }
  }
}));
